var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"phoneLink",on:{"click":_vm.call}},[_c('i',{staticClass:"fa fa-phone"}),_vm._v(" "+_vm._s(_vm.headerNumber)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }